import store from "../index";
import { CLOSE_POPUP, OPEN_POPUP } from "./reducer";

export const showMessage = (type, description, onSubmit) => {
  return store.dispatch({
    type: OPEN_POPUP,
    payload: { type, description, onSubmit },
  });
};

export const showModal = (name) => {
  return store.dispatch({ type: OPEN_POPUP, payload: { type: name } });
};

export const hideModal = () => {
  return store.dispatch({ type: CLOSE_POPUP });
};
